import controlReducer from './controlReducer.js';
import { combineReducers } from 'redux';
import themeReducer from './themeReducer.js';
import riskReducer from './riskReducer.js';
import securityReducer from './securityReducer.js';
import contextReducer from './contextReducer.js';
import cloudModelReducer from './cloudModelsReducer.js';
import configReducer from './configReducer.js';
import complianceReducer from './complianceReducer.js';
import residualRiskReducer from './residualRiskReducer.js';
import monitorsReducer from './monitorsReducer.js'
import riskScenariosReducer from './riskScenariosReducer.js'


const rootReducer = combineReducers({
    themes: themeReducer,
    risks: riskReducer,
    riskScenarios: riskScenariosReducer,
    controls: controlReducer,
    compliance:complianceReducer,
    security:securityReducer,
    context: contextReducer,
    cloudModels:cloudModelReducer,
    config:configReducer,
    residualRisk:residualRiskReducer,
    monitors: monitorsReducer,

});

export default rootReducer;
